import { msg } from '@omegagrid/localize';
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { NodeSource } from '@omegagrid/tree';
import { Module } from "@reporting/rp-types/accounting";
import { Thread } from '@reporting/rp-types/etl';
import rp from '@reporting/rp-app-host';

export class ThreadFormAdapter extends FormAdapter {

	public id: number;

	public duplicate: boolean = false;
	private command_txt: string; // in case of duplicate

	get etlClient() { return rp.ms('etl') }
	get accountingClient() { return rp.ms('accounting') }

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls() {
		const thread = this.id ? (await this.etlClient.get<Thread>(`threads/${this.id}`)) : {};
		if (this.duplicate) {
			thread.description = `${thread.description}_copy`;
			this.id = null;
			this.command_txt = thread.command_txt;
		}
		const threadTypes = await this.etlClient.get<NodeSource[]>(`threadTypes`);
		const modules = (await this.accountingClient.get<Module[]>(`modules`))
			.filter(m => m.type == 'data');

		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'description'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'description', value: thread.description, required: true},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Type')},
			{row: 1, col: 1, type: FormControlType.List, key: 'type', value: thread.type, required: true, content: {
				sourceData: threadTypes, options: {selectMode: 'single', autoClose: true}
			}},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Order')},
			{row: 2, col: 1, type: FormControlType.NumericInput, key: 'ord_num', value: thread.ord_num ?? 1, required: true},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Module')},
			{row: 3, col: 1, type: FormControlType.List, key: 'module', value: thread.module, content: {
				sourceData: modules.map(m => ({k: m.module, v: m.name, icon:{icon: 'cube', color: m.color}})),
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 4, col: 0, type: FormControlType.Label, value: msg('Status')},
			{row: 4, col: 1, type: FormControlType.List, key: 'enabled', value: thread.enabled ?? 2, required: true, content: {
				sourceData: [
					{k: 1, v: msg('Enabled'), icon: {icon: 'eye', color: 'lime'}},
					{k: 0, v: msg('Hidden'), icon: {icon: 'eye-slash', color: 'yellow'}},
					{k: 2, v: msg('Disabled'), icon: {icon: 'circle-xmark', color: 'red'}}
				],
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 5, col: 0, type: FormControlType.Label, value: msg('Sync')},
			{row: 5, col: 1, type: FormControlType.Checkbox, key: 'sync', value: thread.sync ?? true},
			{row: 6, col: 0, type: FormControlType.Label, value: msg('Lock')},
			{row: 6, col: 1, type: FormControlType.Checkbox, key: 'app_lock', value: thread.app_lock ?? false},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null, //'Form1',
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const thread: Thread = {
			id_thread: this.id,
			description: formValues.description as string,
			type: formValues.type as string,
			module: formValues.module as string,
			ord_num: formValues.ord_num as number,
			app_lock: formValues.app_lock as boolean,
			sync: formValues.sync as boolean,
			enabled: formValues.enabled as number,
		};
		if (this.duplicate && this.command_txt) {
			thread.command_txt = this.command_txt;
		}
		await this.etlClient.post(`threads`, thread);
		return true;
		// return [{text: 'Error', type: 'danger'}];
	}
};
